// @flow
import React, { Component } from 'react';
import { Segment, Grid, Form, Header, Icon, Label } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import _ from 'lodash';
import './TreatmentActionForm.scss';
import CounterBuilder from './CounterBuilder';
import { getCounterConstraints } from './constraints';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  parentNode: string,
  parentKeyList: Array<string>,
  onModelChange: (_?: Object) => void,
  handleCloseModal: Function,
  handleInputChange: Function,
  handleControlBlur: Function,
  isAdd: boolean,
  handleDeleteNode: Function,
};

@formComponent()
export default class CounterForm extends Component {
  props: Props;
  constructor(props: Props) {
    super(props);
    this.state = {
      currentNode: this.props.currentNode,
      parentNode: this.props.parentNode,
    };
  }
  handleAddCount = () => {
    const updatedModel = _.cloneDeep(this.props.model);
    const newTargets = _.get(updatedModel.nodes[this.state.currentNode], 'data.targets', []);
    newTargets.push('occurrence-1');
    _.set(updatedModel.nodes[this.state.currentNode], 'data.targets', newTargets);
    this.props.onModelChange(updatedModel);
  }

  handleDeleteCount = (index: number) => {
    const updatedModel = _.cloneDeep(this.props.model);
    const newTargets = _.get(updatedModel.nodes[this.state.currentNode], 'data.targets', []);
    newTargets.splice(index, 1);
    _.set(updatedModel.nodes[this.state.currentNode], 'data.targets', newTargets);
    this.props.onModelChange(updatedModel);
  }
  render() {
    const { model } = this.props;
    const { currentNode, parentNode } = this.state;
    const counterConstraints = getCounterConstraints(currentNode);
    const style = {
      cursor: 'pointer',
    };
    return (
      <div className="treatment-form">
        <Segment className="treatment-form-segment">
          <Grid>
            <Grid.Column width={12}>
              <Header as="h3">Counter Name</Header>
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={12}>
              <Form>
                <Grid>
                  <Grid.Column width={12}>
                    <FormInputWithError
                      name={'nodes.'.concat(`${currentNode}`, '.name')}
                      {...this.props}
                    >
                      <Form.Input
                        required
                        value={model.nodes[currentNode].name}
                        onChange={this.props.handleInputChange}
                        onBlur={this.props.handleControlBlur}
                      />
                    </FormInputWithError>
                  </Grid.Column>
                </Grid>
              </Form>
            </Grid.Column>
          </Grid>
        </Segment>
        <Segment className="treatment-form-segment">
          <Grid columns="equal">
            <Grid.Column>
              <Header as="h3" style={{ paddingTop: '5px' }}>Builder</Header>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Label
                size="medium"
                color="orange"
                style={style}
                onClick={() => this.handleAddCount()}
              >
                <Icon name="add" /> Add
              </Label>
            </Grid.Column>
          </Grid>
          <br />
          <CounterBuilder
            onModelChange={this.props.onModelChange}
            model={this.props.model}
            canActivate={this.props.canActivate}
            currentNode={currentNode}
            parentNode={parentNode}
            parentKeyList={this.props.parentKeyList}
            handleDeleteCount={this.handleDeleteCount}
            handleCloseModal={this.props.handleCloseModal}
            isAdd={this.props.isAdd}
            handleDeleteNode={this.props.handleDeleteNode}
            constraints={counterConstraints}
          />
        </Segment>
      </div>
    );
  }
}
